import { Theme } from "@amx/ux-twoui-theming";
import { HighContrastSelector, IProgressIndicatorStyles } from "@fluentui/react";
import { getFontRampStyle } from "../../styles/fonts";
import { BarHeightType, UsageIndicatorSize } from "./ProgressIndicator";

export const getProgressIndicatorStyles = (theme: Theme, size?: UsageIndicatorSize, progressBarColor?: string, progressTrackColor?: string, barType?: BarHeightType): Partial<IProgressIndicatorStyles> => {

    let customWidth;
    if (size === "wide") {
        customWidth = "480px";
    } else if (size === "narrow") {
        customWidth = "200px";
    }

    let progressBarBorderRadius;
    if (barType === "thick") {
        progressBarBorderRadius = "8px";
    } else if (barType === "thin") {
        progressBarBorderRadius = "4px";
    }

    const styles = getFontRampStyle(theme, "metadataText");
    return {
        itemProgress: {
            padding: "0px",
            borderRadius: "4px"
        },
        itemName: {
            fontSize: styles.fontSize,
            fontWeight: styles.fontWeight,
            lineHeight: styles.lineHeight,
            fontFamily: styles.fontFamily,
            color: styles.color,
            selectors : styles.selectors,
        },
        progressBar: {
            borderRadius: progressBarBorderRadius,
            backgroundColor: progressBarColor,
        },
        progressTrack: {
            borderRadius: progressBarBorderRadius,
            backgroundColor: progressTrackColor,
            [HighContrastSelector]: {
                backgroundColor: "windowText"
            }
        },
        root: {
            maxWidth: customWidth
        }
    };
};
